import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { catchError, map, switchMap } from "rxjs/operators";
import { from, of } from "rxjs";

import { TelespotPipelineService } from "../../services";
import { pipelineActions } from "./pipeline.actions";

@Injectable()
export class TelespotPipelineEffects {
  constructor(
    private actions$: Actions,
    private service: TelespotPipelineService,
  ) { }

  findForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(pipelineActions.findForSample),
      switchMap(({ sampleId }) => from(this.service.findForSample(sampleId)).pipe(
        map(pipelines => pipelineActions.findForSampleSuccess({ pipelines })),
        catchError((error) => of(pipelineActions.findForSampleFailure({ error: error.message }))),
      )),
    )
  );
}
